







import { Component, Vue, Prop } from "vue-property-decorator";
import { TopExpertsTableData } from "@/types";
import BiExpertsTable from "./BiExpertsTable.vue";

@Component({
  name: "BiTopExperts",

  components: {
    BiExpertsTable,
  },
})
export default class BiTopExperts extends Vue {
  @Prop({ type: Array, required: true }) items!: Array<TopExpertsTableData>;

  showExpertsByTask(task: any) {
    this.$gtag.event(`BI_expert_task_${task.id}-${task.name}`)
    // let taskId = task.id
    this.$router.replace({
      name: "BiExpertsByTaskId",
      params: {  taskId: task.id.toString() },
    });
  }
}
